<template>
<div>
    <b-modal
        v-model="setting.isShow"
        centered
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        @hidden="close()" >
        <template slot="modal-title">
        <div slot="header" class="bg-white border-0">
            <div class="row align-items-center">
                <div class="col-12">
                    <h3 class="mb-0">บริการ ออกใบเสร็จพัสดุไปต่างประเทศ</h3>
                </div>
            </div>
        </div>
        </template>
        <card shadow type="secondary" class="m--4">
            <template>
                <form @submit.prevent>
                    <div class>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="group-result">
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6><small class="text-danger">* </small>เลข Tracking Code</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.trackingCode"
                                                :class="{ 'is-invalid': submit && $v.setting.data.trackingCode.$error }"
                                            />
                                            <!-- error msg -->
                                            <div
                                                v-if="submit && !$v.setting.data.trackingCode.required"
                                                class="invalid-feedback d-block" >
                                                กรุณากรอก Tracking Code
                                            </div>
                                            <div
                                                class="error invalid-feedback d-block"
                                                v-if="submit && !$v.setting.data.trackingCode.minLength" >

                                                    กรุณากรอก"Tracking Code"อย่างน้อย {{$v.setting.data.trackingCode.$params.minLength.min}} หลัก
                                            </div>
                                            <div
                                                class="error invalid-feedback d-block"
                                                v-if="submit && !$v.setting.data.trackingCode.maxLength" >

                                                กรุณากรอก"Tracking Code"ไม่เกิน {{$v.setting.data.trackingCode.$params.maxLength.max}} หลัก
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6><small class="text-danger">* </small>ชื่อผู้ส่ง</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.fromName"
                                                :class="{ 'is-invalid': submit && $v.setting.data.fromName.$error }"
                                            />
                                            <!-- error msg -->
                                            <div
                                                v-if="submit && !$v.setting.data.fromName.required"
                                                class="invalid-feedback d-block" >
                                                กรุณากรอก ชื่อผู้ส่ง
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6><small class="text-danger">* </small>ชื่อผู้รับ</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="text"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.toName"
                                                :class="{ 'is-invalid': submit && $v.setting.data.toName.$error }"
                                            />
                                            <!-- error msg -->
                                            <div
                                                v-if="submit && !$v.setting.data.toName.required"
                                                class="invalid-feedback d-block" >
                                                กรุณากรอก ชื่อผู้รับ
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6><small class="text-danger">* </small>น้ำหนัก (กรัม)</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="number"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.weight"
                                                :class="{ 'is-invalid': submit && $v.setting.data.weight.$error }"
                                            />
                                            <!-- error msg -->
                                            <div
                                                v-if="submit && !$v.setting.data.weight.required"
                                                class="invalid-feedback d-block" >
                                                กรุณากรอก น้ำหนัก
                                            </div>
                                             <div
                                                class="error invalid-feedback"
                                                v-if="submit && !$v.setting.data.weight.numeric">
                                                กรุณากรอกเฉพาะตัวเลข
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6><small class="text-danger">* </small>จำนวนเงิน (บาท)</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="number"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.amount"
                                                :class="{ 'is-invalid': submit && $v.setting.data.amount.$error }"
                                            />
                                            <!-- error msg -->
                                            <div
                                                v-if="submit && !$v.setting.data.amount.required"
                                                class="invalid-feedback d-block" >
                                                กรุณากรอก จำนวนเงิน
                                            </div>
                                             <div
                                                class="error invalid-feedback"
                                                v-if="submit && !$v.setting.data.amount.numeric">
                                                กรุณากรอกเฉพาะตัวเลข
                                            </div>
                                        </div>
                                    </div>
                                    <div class="price">
                                        <div class="col-lg-6">
                                            <h6>ค่าบริการ (บาท)</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <input
                                                type="number"
                                                class="form-control form-control-sm"
                                                v-model="setting.data.fee"
                                            />
                                        </div>
                                    </div><div class="price">
                                        <div class="col-lg-6">
                                            <h6>หมายเหตุ</h6>
                                        </div>
                                        <div class="col-lg-6">
                                            <textarea 
                                                class="form-control form-control-sm" 
                                                rows="2"
                                                v-model="setting.data.remark" >
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="close()">ยกเลิก</b-button>
                        <b-button type="submit" variant="success" @click="addOrder()">ยืนยัน</b-button>
                    </div>
                </form>
            </template>
        </card>
    </b-modal>
</div>
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators"
export default {
    name:'interparcelservice',
    props: {
        setting: Object,
        confirmFunc: Function,
    },
    data() {
        return {
            isShow: false,
            submit: false
        }
    },
    validations: {
        setting:{
            data:{
                trackingCode: { 
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20)
                },
                fromName: { required },
                toName: { required },
                weight: { required , numeric },
                amount: { required , numeric }
            }
        }
    },
    methods:{
        close(){
            this.setting.isShow = false
            this.clearInput()
            this.setActionSubmit()
        },
        setActionSubmit( bool = false ){
            this.submit = bool
        },
        addOrder(){
            this.setActionSubmit( true )
            this.$v.setting.$touch()
            if( this.$v.setting.$invalid ){
                return false
            }
            this.confirmFunc()
            this.close()
        },
        clearInput(){
            Object.keys(this.setting.data).forEach(key => {
                this.setting.data[key] = ""
            })
        }
    }
    // watch: {
    //     'setting.isShow': function ( last , old ){
    //         this.isShow = last

    //     }
    // }

}
</script>